<template>
  <b-row>
    <ProfilePicture />

    <ProfileDetails
      :productsData="data.ProductGroups"
      :userData="data.generalInfo"
      v-if="propsReady"
    />

    <ProfileLocations :locationData="data.Locations" v-if="propsReady" />
  </b-row>
</template>

<script>
import ProfilePicture from "../../components/ProfilePicture";
import ProfileDetails from "../../components/ProfileDetails";
import ProfileLocations from "../../components/ProfileLocations";

export default {
  name: "dashboard",
  components: {
    ProfilePicture,
    ProfileDetails,
    ProfileLocations
  },
  data() {
    return {
      user: null,
      data: [],
      propsReady: false
    };
  },
  methods: {
    getInfo() {
      let params = {};
      params = {
        userId: this.user
      };
      this.$http
        .get("api/commscope/profile/userInfo.php", { params })
        .then(
          res => {
            this.data = res.data;
            this.propsReady = true;
          },
          err => {
            console.log(err);
          }
        );
    }
  },
  mounted() {
    this.user = localStorage.getItem("com_user");
    this.getInfo();
  }
};
</script>

<style scoped>
</style>
